import { InvitationsService } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

export class AcceptInvitationRejectedError extends Error {}

type TParams = {
  call: TCall;
  invitationId: string;
};

export const acceptInvitation = async ({ call, invitationId }: TParams) => {
  const response = await call(() => InvitationsService.acceptInvitation({ invitationId }));

  if (!response.success) {
    throw new AcceptInvitationRejectedError(response.error ?? response.message ?? 'Unable to accept the invitation');
  }

  return response;
};
